import React, { useState } from 'react';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import Brief from '../components/Brief';
import Counterparty from '../components/Counterparty';
import Contracts from '../components/Contracts';
import Notifications from '../components/Notifications';
import Sources from '../components/Sources';
import Settings from '../components/Settings';
import Onboarding from '../components/Onboarding';
import OneTime from '../components/OneTime';
import NPS from '../components/NPS';
import Analytics from '../components/Analytics';
import LawUpdates from '../components/LawUpdates';
import S1Invoices from '../components/S1Invoices';
import BankGuarantees from '../components/BankGuarantees';
import Tenders from '../components/Tenders';
import { canAccess } from '../checkPlan';

function Dashboard({ onLogout }) {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('khepri_user') || '{}');
  const [showOnboarding, setShowOnboarding] = useState(!localStorage.getItem('onboarding_done'));

  const finishOnboarding = () => {
    localStorage.setItem('onboarding_done', '1');
    setShowOnboarding(false);
  };

  if (showOnboarding) {
    return <Onboarding onDone={finishOnboarding} />;
  }

  return (
    <div>
      <header style={{ display: 'flex', justifyContent: 'space-between', padding: '16px 0', borderBottom: '1px solid #334155', marginBottom: 16 }}>
        <span style={{ fontSize: 22, fontWeight: 700 }}>Khepri</span>
        <div>
          <span style={{ marginRight: 12, color: '#94A3B8', fontSize: 14 }}>{user.name || 'User'}</span>
          <button onClick={() => { onLogout(); navigate('/login'); }} style={{ background: '#334155', color: '#F8FAFC', border: 'none', padding: '6px 12px', borderRadius: 6, cursor: 'pointer' }}>Logout</button>
        </div>
      </header>

      <nav style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        {/* 🔴 Ежедневно */}
        <Link to="/" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Today</Link>
        {canAccess('counterparty') && <Link to="/counterparty" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Counterparty</Link>}
        {canAccess('contracts') && <Link to="/contracts" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Contracts</Link>}
        {canAccess('notifications') && <Link to="/notifications" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Notifications</Link>}

        {/* 🟡 Финансы и документы */}
        <Link to="/tenders" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Tenders</Link>
        <Link to="/guarantees" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Guarantees</Link>
        <Link to="/s1" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>1C</Link>

        {/* 🟢 Законы и сервисы */}
        <Link to="/law-updates" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Laws</Link>
        <Link to="/one-time" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Services</Link>
        {canAccess('sources') && <Link to="/sources" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Sources</Link>}

        {/* ⚪ Сервисное */}
        {canAccess('settings') && <Link to="/settings" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Settings</Link>}
        <Link to="/analytics" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Analytics</Link>
        <Link to="/nps" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Rate Us</Link>
      </nav>

      <Routes>
        {/* 🔴 Ежедневно */}
        <Route path="/" element={<Brief />} />
        {canAccess('counterparty') && <Route path="/counterparty" element={<Counterparty />} />}
        {canAccess('contracts') && <Route path="/contracts" element={<Contracts />} />}
        {canAccess('notifications') && <Route path="/notifications" element={<Notifications />} />}

        {/* 🟡 Финансы и документы */}
        <Route path="/tenders" element={<Tenders />} />
        <Route path="/guarantees" element={<BankGuarantees />} />
        <Route path="/s1" element={<S1Invoices />} />

        {/* 🟢 Законы и сервисы */}
        <Route path="/law-updates" element={<LawUpdates />} />
        <Route path="/one-time" element={<OneTime />} />
        {canAccess('sources') && <Route path="/sources" element={<Sources />} />}

        {/* ⚪ Сервисное */}
        {canAccess('settings') && <Route path="/settings" element={<Settings />} />}
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/nps" element={<NPS />} />
      </Routes>
    </div>
  );
}

export default Dashboard;